module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"OrdersOrLots\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/order-or-lots/order-or-lots.component.html
// module id = ./src/app/order-or-lots/order-or-lots.component.html
// module chunks = main